"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Iterable_instances, _Iterable_tokenData, _Iterable_logoutUser, _Iterable_loginUser, _Iterable_fetchJWT, _Iterable_decodeJWT, _Iterable_updateUserProfile;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Iterable = void 0;
const IterableSDK = __importStar(require("@3d4medical/iterable-web-sdk"));
const http_1 = require("@completeanatomy/http");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
require("reflect-metadata");
const typedi_1 = require("typedi");
const PACKAGE_NAME = 'Complete Anatomy';
const MESSAGES_COUNT = 20;
const DISPLAY_INTERVAL = 10000;
let Iterable = class Iterable {
    constructor(http) {
        _Iterable_instances.add(this);
        this.http = http;
        /**
         * Decoded JWT token from CA backend, used to sign Iterable SDK calls
         * This is separate token and is not the same that used by Auth package
         */
        _Iterable_tokenData.set(this, {});
        _Iterable_logoutUser.set(this, void 0);
        _Iterable_loginUser.set(this, void 0);
    }
    /**
     * Initialize iterable, save callbacks for auth
     *
     * @param apiKey - Iterable API key
     *
     * @returns void
     */
    initIterableWithKey(apiKey) {
        const { setUserID, logout } = IterableSDK.initialize(apiKey, () => __awaiter(this, void 0, void 0, function* () {
            const token = yield __classPrivateFieldGet(this, _Iterable_instances, "m", _Iterable_fetchJWT).call(this);
            yield __classPrivateFieldGet(this, _Iterable_instances, "m", _Iterable_decodeJWT).call(this, token);
            return token;
        }));
        __classPrivateFieldSet(this, _Iterable_logoutUser, logout, "f");
        __classPrivateFieldSet(this, _Iterable_loginUser, setUserID, "f");
    }
    /**
     * Login user that is currently authenticated
     *
     * @param userId - ID of user to login
     *
     * @returns Promise<void>
     */
    loginIterable(userId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield ((_a = __classPrivateFieldGet(this, _Iterable_loginUser, "f")) === null || _a === void 0 ? void 0 : _a.call(this, userId));
        });
    }
    /**
     * Logout user that is currently authenticated
     *
     * @returns void
     */
    logoutIterable() {
        var _a;
        (_a = __classPrivateFieldGet(this, _Iterable_logoutUser, "f")) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    /**
     * Fetch In App Messages for authenticated user
     * and set their options
     *
     * @returns Promise<void>
     *
     * @public
     */
    fetchAndShowIAM(linkOpeningCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            const { request } = IterableSDK.getInAppMessages({
                count: MESSAGES_COUNT,
                packageName: PACKAGE_NAME,
                displayInterval: DISPLAY_INTERVAL,
                handleLinks: IterableSDK.HandleLinks.ExternalNewTab,
            }, {
                display: IterableSDK.DisplayOptions.Immediate,
                externalLinksCallback: linkOpeningCallback,
            });
            /* trigger the start of message presentation */
            try {
                yield request();
            }
            catch (error) {
                console.warn(`Iterable IAM error: ${error}`);
            }
        });
    }
    /**
     * Update app info related user profile fields
     *
     * @param version - App version
     * @param platform - App platform
     *
     * @returns Promise<void>
     *
     * @public
     */
    updateAppInfo(version, platform) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFields = {
                desktopAppPlatform: platform,
                desktopAppVersion: version,
            };
            const data = {
                dataFields,
                mergeNestedObjects: true,
            };
            __classPrivateFieldGet(this, _Iterable_instances, "m", _Iterable_updateUserProfile).call(this, data);
        });
    }
    /**
     * Get decoded CA backend JWT token
     *
     * @returns DecodedJWT
     */
    getTokenData() {
        return __classPrivateFieldGet(this, _Iterable_tokenData, "f");
    }
};
exports.Iterable = Iterable;
_Iterable_tokenData = new WeakMap();
_Iterable_logoutUser = new WeakMap();
_Iterable_loginUser = new WeakMap();
_Iterable_instances = new WeakSet();
_Iterable_fetchJWT = function _Iterable_fetchJWT() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield this.http.get({
            path: 'jwt-iterable/',
            backend: http_1.Backend.SSO,
            apiPrefix: http_1.APIPrefix.None,
        });
        const { web } = (yield response.json());
        return web;
    });
};
_Iterable_decodeJWT = function _Iterable_decodeJWT(token) {
    return __awaiter(this, void 0, void 0, function* () {
        const decodedToken = (0, jwt_decode_1.default)(token);
        __classPrivateFieldSet(this, _Iterable_tokenData, decodedToken, "f");
    });
};
_Iterable_updateUserProfile = function _Iterable_updateUserProfile(data) {
    return __awaiter(this, void 0, void 0, function* () {
        IterableSDK.updateUser(data);
    });
};
/**
 * Name of exported module property
 */
Iterable.exportName = 'iterable';
exports.Iterable = Iterable = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [http_1.HTTP])
], Iterable);
